'use strict';

angular.module(ApplicationConfiguration.applicationModuleName).controller('productsegmentEditCtrl', function ($scope, $rootScope, $window, $state, $http, $filter, MessageService, model, ProductSegment) {
	var vm = this;

	var $translate = $filter('translate');

	vm.model = model;

	angular.extend($scope.$parent.vm, {
		title: 'productSegments.settings.title',
		insertUrl: null
	});

	$rootScope.laddaLoading = false;

	vm.save = function () {
		$rootScope.laddaLoading = true;


		if (!vm.model.productSegmentId) {
			ProductSegment.insert(vm.model, function () {
				$state.go('main.productsegment');
			}, function (response) {
				MessageService.alertError(response.data);
			});
		} else {
			ProductSegment.update(vm.model, function () {
				$state.go('main.productsegment');
			}, function (response) {
				MessageService.alertError(response.data);
			});
		}
	}
});